import { GetStaticProps, NextPage } from "next";

import { BluetoothLandingPage } from "@components/bluetooth-landing/BluetoothLandingPage";
import * as copy from "@data/warsztaty-produktowe-landing/plCopy";

const WarsztatyProduktowePage: NextPage = () => (
  <BluetoothLandingPage
    metadata={{
      title: copy.title,
      description: copy.description,
      canonicalPath: "/warsztaty-produktowe",
      lang: "pl",
      ogLocale: "pl_PL",
      structuredData: copy.structuredData,
      alternatePaths: {
        pl: "/warsztaty-produktowe",
        xDefault: "/warsztaty-produktowe",
      },
    }}
    heroCopy={copy.heroCopy}
    targetAudienceCopy={copy.targetAudienceCopy}
    valuePropositionCopy={copy.valuePropositionCopy}
    servicesCopy={copy.servicesCopy}
    processCopy={copy.processCopy}
    aboutUsCopy={copy.aboutUsCopy}
    faqCopy={copy.faqCopy}
    footerCopy={copy.footerCopy}
  />
);

export const getStaticProps: GetStaticProps = async () => ({
  props: {},
});

export default WarsztatyProduktowePage;
